<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Boutiques
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des boutiques</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Tabs -->
    <ul class="afri-tabs nav" style="padding: 0 1.5rem;">
      <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" href="#tab-animated1-0" aria-selected="true">
          <span class="nav-text">Boutiques</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" href="#tab-animated1-1" aria-selected="false">
          <span class="nav-text">Restaurant</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-2" data-bs-toggle="tab" href="#tab-animated1-2" aria-selected="false">
          <span class="nav-text">Commandes</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">

      <!-- Tab 1: Boutiques -->
      <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
            <button *ngIf="buttonsPermission.status && selected_data?.status!='visible'" (click)="setState(1)" [disabled]="loading" class="btn-afri-success">
              Rendre visible <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="buttonsPermission.status && selected_data?.status=='visible'" (click)="setState(0)" [disabled]="loading" class="btn-afri-danger">
              Cacher <app-loading [isVisible]="loading"></app-loading>
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Logo</th>
                <th>Bannière</th>
                <th>Nom</th>
                <th>Référence</th>
                <th>Propriétaire</th>
                <th>Contact</th>
                <th>Description</th>
                <th>Adresse</th>
                <th>Statut</th>
                <th>Article</th>
                <th>Admin</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data | paginate: {
                    id: 'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td><img [src]="d.logo_external_url" height="10px" alt=""></td>
                <td><img [src]="d.banner_external_url" height="10px" alt=""></td>
                <td>{{d.name}}</td>
                <td>{{d.reference}}</td>
                <td>{{d.user?.lastname}} {{d.user?.firstname}}</td>
                <td>{{d.user?.phone_number}}</td>
                <td>{{d.description}}</td>
                <td>{{d.address}}</td>
                <td><app-status [value]="d.status"></app-status></td>
                <td>-</td>
                <td>-</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="data.length === 0 && !loading2">
                <td colspan="14" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP1"
            (pageChange)="getPage1($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 1 -->

      <!-- Tab 2: Restaurant -->
      <div class="tab-pane" id="tab-animated1-1" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission2">
            <button *ngIf="buttonsPermission2.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission2.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission2.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission2.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
            <button *ngIf="buttonsPermission2.status && selected_data?.status!='visible'" (click)="setState2(1)" [disabled]="loading" class="btn-afri-success">
              Rendre visible <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="buttonsPermission2.status && selected_data?.status=='visible'" (click)="setState2(0)" [disabled]="loading" class="btn-afri-danger">
              Cacher <app-loading [isVisible]="loading"></app-loading>
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ dataFoods!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Logo</th>
                <th>Bannière</th>
                <th>Nom</th>
                <th>Référence</th>
                <th>Propriétaire</th>
                <th>Contact</th>
                <th>Description</th>
                <th>Adresse</th>
                <th>Statut</th>
                <th>Plat</th>
                <th>Admin</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of dataFoods | paginate: {
                    id: 'ngxP2',
                    itemsPerPage: pg2.pageSize,
                    currentPage: pg2.p,
                    totalItems: pg2.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td><img [src]="d.logo_external_url" height="10px" alt=""></td>
                <td><img [src]="d.banner_external_url" height="10px" alt=""></td>
                <td>{{d.name}}</td>
                <td>{{d.reference}}</td>
                <td>{{d.user?.lastname}} {{d.user?.firstname}}</td>
                <td>{{d.user?.phone_number}}</td>
                <td>{{d.description}}</td>
                <td>{{d.address}}</td>
                <td><app-status [value]="d.status"></app-status></td>
                <td>-</td>
                <td>-</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="dataFoods.length === 0 && !loading2">
                <td colspan="14" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP2"
            (pageChange)="getPage2($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 2 -->

      <!-- Tab 3: Commandes -->
      <div class="tab-pane" id="tab-animated1-2" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission3">
            <button *ngIf="buttonsPermission3.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission3.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission3.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission3.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ dataOrders!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Référence</th>
                <th>Acheteur</th>
                <th>Vendeur</th>
                <th>Articles</th>
                <th>Achats</th>
                <th>Gain du store</th>
                <th>Paiement</th>
                <th>Statut</th>
                <th>Date COM</th>
                <th>DATE MOD</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of dataOrders | paginate: {
                    id: 'ngxP3',
                    itemsPerPage: pg3.pageSize,
                    currentPage: pg3.p,
                    totalItems: pg3.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.reference}}</td>
                <td>{{d.customer?.lastname}}{{d.customer?.firstname}}</td>
                <td>{{d.seller?.lastname}}{{d.seller?.firstname}}</td>
                <td>
                  <ul>
                    @for (it of d.items; track it) {
                      <li>{{it.article?.name}}</li>
                    }
                  </ul>
                </td>
                <td>{{d.amount}}</td>
                <td>{{d.gain}}</td>
                <td>{{d.payment_type}}</td>
                <td><app-status [value]="d.status"></app-status></td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="dataOrders.length === 0 && !loading2">
                <td colspan="11" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP3"
            (pageChange)="getPage3($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 3 -->

    </div><!-- end tab-content -->

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Enregistrer un rôle</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Libellé du rôle <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" ngModel>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier un rôle</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Libellé <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" [(ngModel)]="selected_data.name">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive table-card">
      <table class="table table-borderless align-middle mb-0">
        <tbody></tbody>
      </table>
    </div>
  </div>
</ng-template>
